import KpRecordCollectionContentPage from './KpRecordCollectionContentPage.svelte';
import type {RecordCollectionManager} from '../record-collection-manager';
import type {RecordCollectionsDataService} from '../record-collections.data-service';
import type {UUID} from 'typings/portaro.be.types';
import type {RecordCollectionViewConfiguration} from 'typings/portaro.fe.types';
import type {RecordCollectionManagerFactory} from '../record-collection-manager.factory';

export default class RecordCollectionContentPageController {

    public kpRecordCollectionContentPageComponent = KpRecordCollectionContentPage;

    public static async getConfiguration(recordCollectionsDataService: RecordCollectionsDataService, collectionId: UUID): Promise<RecordCollectionViewConfiguration> {
        return recordCollectionsDataService.getPageSettings(collectionId);
    }

    public static async getCollectionManager(recordCollectionsDataService: RecordCollectionsDataService, recordCollectionManagerFactory: RecordCollectionManagerFactory, collectionId: UUID): Promise<RecordCollectionManager> {
        const collection = await recordCollectionsDataService.getCollection(collectionId, true);
        return recordCollectionManagerFactory.createAndInitialize(collection);
    }

    /*@ngInject*/
    constructor(public viewConfiguration: RecordCollectionViewConfiguration,
                public recordCollectionManager: RecordCollectionManager) {
    }
}
